import React from 'react'
import { useHistory } from 'react-router-dom'

function useFormValidation (initialState, validate, authenticate) {
  const [values, setValues] = React.useState(initialState)
  const [errors, setErrors] = React.useState({})
  const [isSubmitting, setSubmitting] = React.useState(false)
  const history = useHistory()
  React.useEffect(() => {
    if (isSubmitting) {
      const noErrors = Object.keys(errors).length === 0
      if (noErrors) {
        authenticate()
        setSubmitting(false)
        history.push('/mb')
      } else {
        setSubmitting(false)
        history.push('/')
      }
    }
  }, [errors])

  function handleChange (event) {
    event.persist()
    setValues(previousValues => ({
      ...previousValues,
      [event.target.name]: event.target.value
    }))
  }

  function handleBlur () {
    const validationErrors = validate(values)
    setErrors(validationErrors)
  }

  function handleSubmit (event) {
    event.preventDefault()
    const validationErrors = validate(values)
    setErrors(validationErrors)
    setSubmitting(true)
  }

  return {
    handleSubmit,
    handleBlur,
    handleChange,
    values,
    errors,
    isSubmitting
  }
}

export default useFormValidation
